/**
 * 基础菜单 科目管理
 */
<template>
  <div style="height: 100%">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>科目管理</el-breadcrumb-item>
    </el-breadcrumb>


    <div class="tree-con">
      <div class="head-search">
        <el-input
          v-model="treeName"
          maxLength="15"
          placeholder="请输入"
          clearable
          size="small"
        >
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </div>

      <!-- 科目树 -->
      <div class="head-tree">
        <el-tree
          :data="treeOptions"
          :props="defaultProps"
          :filter-node-method="filterNode"
          :expand-on-click-node="false"
          ref="tree"
          node-key="value"
          highlight-current
          :default-expanded-keys="treeArr"
          @node-click="handleNodeClick"
          @node-contextmenu="rightUpdata"
        >
          <div class="custom-tree-node" slot-scope="{ node, data }">
            <i
              class="custom-tree-node-icon"
              :class="node.isLeaf ? 'el-icon-aim' : 'el-icon-folder-opened'"
            ></i>
            <span
              class="s_l custom-tree-node-name "
              :title="data.label"
              :style="{ 'font-weight': node.isLeaf ? '400' : 'bold' }"
            >{{ data.label }}</span
            >
          </div>
        </el-tree>
      </div>

    </div>

    <!-- 右侧部分 -->
    <div class="con-rig">
      <div>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="queryParams" class="user-search" style="float: right;">
          <!--        <el-form-item label="搜索：">
                    <el-input size="small" v-model="queryParams.typeName" placeholder="输入科目名称"></el-input>
                  </el-form-item>-->
          <el-form-item>
            <!--          <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>-->
            <el-button size="small" type="primary" icon="el-icon-plus" v-show="addShow && listData.length == 0" @click="handleFormEdit()">添加</el-button>
          </el-form-item>
        </el-form>
        <!--列表-->
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column label="序号" align="center" type="index" width="60">
          </el-table-column>
          <el-table-column prop="notice" label="报名须知">
          </el-table-column>
          <el-table-column prop="ageLimit" label="年龄限制" width="100">
          </el-table-column>
          <el-table-column prop="beforeDay" label="复审截止时间前" width="140">
          </el-table-column>
          <el-table-column prop="afterDay" label="复审截止时间后" width="140">
          </el-table-column>
          <el-table-column prop="attachRequest" label="附件要求">
          </el-table-column>

          <el-table-column align="center" label="操作" width="150">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleFormEdit(scope.$index, scope.row)">编辑</el-button>
              <el-button size="mini" type="danger" @click="deleteKmPz(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <!--      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>-->
      </div>


      <div>
        <el-divider content-position="left">培训大纲</el-divider>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="queryParams" style="float: right;">
          <!--        <el-form-item label="搜索：">
                    <el-input size="small" v-model="queryParams.typeName" placeholder="输入科目名称"></el-input>
                  </el-form-item>-->
          <el-form-item>
            <!--          <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>-->
            <el-button size="small" type="primary" icon="el-icon-plus" v-if="detailSubjectId" @click="openWlxy = true">添加</el-button>
          </el-form-item>
        </el-form>
        <!--列表-->
        <el-table size="small" :data="myWlxyList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column label="序号" align="center" type="index" width="60">
          </el-table-column>
          <el-table-column prop="wlxyBjMc" label="培训班级名称"/>
          <el-table-column prop="zt" label="状态">
            <template slot-scope="scope">
              {{ scope.row.zt == 1 ? '启用' : '停用' }}
            </template>
          </el-table-column>

          <el-table-column align="center" label="操作" width="150">
            <template slot-scope="scope">
              <el-button size="mini" @click="changeWlxyZt(scope.row)">
                {{ scope.row.zt == 1 ? '停用' : '启用' }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <!--      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>-->
      </div>
    </div>


    <!--  科目新增 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormShow" width="30%" :close-on-click-modal="false" @click="closeDialog">
      <el-form label-width="120px" :model="form" :rules="rules" ref="form">
        <el-form-item label="父级科目" prop="parentName">
          <el-input @focus="openType" v-model="form.parentName" placeholder="请选择父级科目"/>
        </el-form-item>
        <el-form-item label="培训科目" prop="typeName">
          <el-input size="small" maxLength="100" v-model="form.typeName" placeholder="请输入科目名称"></el-input>
        </el-form-item>
        <el-form-item label="学时" prop="passHour">
          <el-input size="small" v-model="form.passHour" @input="formatInportData($event,'11','passHour',form)" placeholder="请输入学时"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('form')">保存</el-button>
      </div>
    </el-dialog>

    <!-- 选择 父级项目 -->
    <el-dialog :close-on-click-modal="false" title="选择父级项目" width="20vw" top="6vh" :visible.sync="openUpType" append-to-body>
      <div class="tree-con " style="margin: 0 auto">

        <div class="head-search">
          <el-input
            v-model="treeName2"
            maxLength="15"
            placeholder="请输入"
            clearable
            size="small"
          >
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </div>

        <div class="head-tree">
          <el-tree
            :data="treeOptions"
            :props="defaultProps"
            :filter-node-method="filterNode"
            :expand-on-click-node="false"
            ref="tree"
            node-key="value"
            :default-expanded-keys="treeArr"
            @node-click="handleNodeClick2"
          >
            <div class="custom-tree-node" slot-scope="{ node, data }">
              <i
                class="custom-tree-node-icon"
                :class="node.isLeaf ? 'el-icon-aim' : 'el-icon-folder-opened'"
              ></i>
              <span
                class="s_l custom-tree-node-name "
                :title="data.label"
                :style="{ 'font-weight': node.isLeaf ? '400' : 'bold' }"
              >{{ data.label }}</span
              >
            </div>
          </el-tree>
        </div>

      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitUpType">确 定</el-button>
        <el-button @click="cancelUpType">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 鼠标右击 树菜单栏 -->
    <div v-show="menuVisible">
      <div id="menu" class="menu">
        <div class="menu-item" @click="handleEdit(1)">新增</div>
        <div class="menu-item" @click="handleEdit(2)">编辑</div>
        <div class="menu-item" @click="deleteUser">删除</div>
      </div>
    </div>


    <el-dialog title="选择培训大纲" :visible.sync="openWlxy" width="70%" :close-on-click-modal="false" @click="openWlxy = false">
      <WlxyList :flag="2" v-on:wlxyData="wlxyData"></WlxyList>
    </el-dialog>

    <!--  科目配置 新增 -->
    <el-dialog :title="detailTitle" :visible.sync="detailShow" width="30%" :close-on-click-modal="false" @click="detailClose">
      <el-form label-width="120px" :model="detailForm" :rules="detailRules" ref="detailForm">
<!--        <el-form-item label="培训科目" prop="subjectId">
          <el-cascader
            size="small"
            style="width: 100%"
            v-model="detailForm.subjectId"
            :options="treeOptions"
            emitPath="false"
            :props="{ checkStrictly: true, emitPath:false }"
            clearable
          ></el-cascader>
        </el-form-item>-->
        <el-form-item label="报名须知" prop="notice">
          <el-input size="small" maxLength="255" type="textarea" :rows="3" v-model="detailForm.notice" placeholder="请输入报名须知"/>
        </el-form-item>
        <el-form-item label="年龄限制" prop="ageLimit">
          <el-input size="small" maxLength="255" v-model="detailForm.ageLimit" placeholder="请输入年龄限制"></el-input>
        </el-form-item>
        <el-form-item label="附件要求" prop="attachRequest">
          <el-input size="small" maxLength="255" type="textarea" :rows="3" v-model="detailForm.attachRequest" placeholder="请输入附加要求"></el-input>
        </el-form-item>
        <el-form-item label="复审截止时间前" prop="beforeDay">
          <el-input size="small" maxLength="11" v-model="detailForm.beforeDay" @input="formatInportData($event,'11','beforeDay',detailForm)" placeholder="请输入复审截止时间前天数"></el-input>
        </el-form-item>
        <el-form-item label="复审截止时间后" prop="afterDay">
          <el-input size="small" maxLength="11" v-model="detailForm.afterDay" @input="formatInportData($event,'11','afterDay',detailForm)" placeholder="请输入复审截止时间后天数"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="detailClose">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitDetailForm()">保存</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  // 科目
  querySubjectList,
  selectAreaTree,
  saveSubject,
  updateSubject,
  deleteSubjectById,
  querySubjectDetail,


  // 科目配置
  findSubjectDescribeList,
  savaSubjectDescribe,
  updateSubjectDescribe,
  deleteSubjectDescribe,
  querySubjectDescribeDetail,
  querySubjectDescribeBySubjectId, getWlxyList, findWlxyById, changeWlxy, addWlxy       // 根据科目id 查询科目配置信息

} from '../../api/subjectTree'
import { formatInportData } from '../../utils/util'
import Pagination from '../../components/Pagination'
import Template from "../../components/template";
import WlxyList from "./wlxyList.vue";
import {deleteRoomById} from "../../api/userMG";
import {req} from "../../api/axiosFun";

export default {
  data() {
    return {
      addShow: false,
      id: '',
      loading: false, //是显示加载
      editFormShow: false, //控制编辑页面显示与隐藏
      title: '新增',
      form: {},
      // rules表单验证
      rules: {
        typeName: [
          { required: true, message: '请输入科目名称', trigger: 'blur' }
        ],
        passHour: [
          { required: true, message: '请输入学时', trigger: 'blur' }
        ]
      },
      queryParams: {
        page: 1,
        size: 10
      },
      listData: [], //用户数据
      myWlxyList: [],
      openWlxy: false,

      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

      openUpType: false,
      // 左侧树
      treeArr: [],  // 默认展示第二级树节点
      treeName: undefined,
      treeName2: undefined,
      treeOptions: undefined,
      defaultProps: {
        children: "children",
        label: "label"
      },
      // 树状图 双击事件参数
      treeClickCnt: 0,
      treeClickTimeout: null,

      // 右键点击 菜单
      menuVisible: false,


      // 科目配置 信息
      detailSubjectId: '',
      detailShow: false,
      detailTitle: '添加',
      detailForm: {},
      detailRules: {
        notice: [
          { required: true, message: '请输入报名须知', trigger: 'blur' }
        ],
        ageLimit: [
          { required: true, message: '请输入年龄限制', trigger: 'blur' }
        ],
        attachRequest: [
          { required: true, message: '请输入附加要求', trigger: 'blur' }
        ],
        beforeDay: [
          { required: true, message: '请输入复审截止日期前天数', trigger: 'blur' }
        ],
        afterDay: [
          { required: true, message: '请输入复审截止日期后天数', trigger: 'blur' }
        ],
      }
    }
  },
  watch: {
    // 根据名称筛选部门树
    treeName(val) {
      this.$refs.tree.filter(val);
    },
    treeName2(val) {
      this.$refs.tree.filter(val);
    }
  },
  // 注册组件
  components: {
    WlxyList,
    Template,
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.initData();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    formatInportData,
    initData() {
      this.selectAreaTree()
      // this.getdata()
    },

    // 查询 科目树
    selectAreaTree() {
      selectAreaTree({}).then(res => {
        if (res.code == 200) {
          this.treeOptions = res.data;
          res.data.forEach(x => {
            this.treeArr.push(x.value)
          })
        }
      })
    },
    // 筛选树节点
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 节点单击事件
    handleNodeClick(data) {
      console.log('data', data);
      this.$refs.tree.setCurrentKey(data.value);
      this.detailSubjectId = data.value;
      this.querySubjectDescribeBySubjectId(data.value);
      this.queryWlxyBySubjectId(data.value);
    },
    querySubjectDescribeBySubjectId(id) {
      querySubjectDescribeBySubjectId({subjectId: id}).then(res => {
        if (res.code == 200) {
          this.addShow = true;
          if (res.data != '' && res.data != null && res.data != undefined) {
            this.listData = [res.data];
          } else {
            this.listData = [];
          }
        }
      })
    },
    queryWlxyBySubjectId(id) {
      findWlxyById(id).then(res => {
        if (res.code == 200) {
          if (res.data != '' && res.data != null && res.data != undefined) {
            this.myWlxyList = res.data;
          } else {
            this.myWlxyList = [];
          }
        }
      })
    },

    wlxyData(item) {

      var list = [];
      item.forEach(x => {
        list.push({
          wlxyBjId: x.Id,
          wlxyBjMc: x.Name
        })
      })

      var params = {
        subjectId: this.detailSubjectId,
        wlxySubjectList: list
      }

      addWlxy(JSON.stringify(params)).then(res => {
        this.openWlxy = false;
        if (res.code == 200) {
          this.queryWlxyBySubjectId(this.detailSubjectId)
          this.$message({
            type: 'success',
            message: '保存成功！'
          })
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
        .catch(err => {
          this.openWlxy = false
          this.$message.error('保存失败，请稍后再试！')
        })
    },

    changeWlxyZt(row) {

      var params = {
        id: row.id,
      }
      var title = ''
      if (row.zt == '1') {
        title = '确定要停用该条数据吗?'
        params.zt = 0;
      } else if (row.zt == '0') {
        title = '确定要启用该条数据吗?'
        params.zt = 1;
      }

      console.log('title  ', title);

      this.$confirm(title, '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          changeWlxy(params).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '操作成功!'
              })
              this.queryWlxyBySubjectId(row.subjectId);
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
            .catch(err => {
              this.loading = false
              this.$message.error('操作失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },

    // 鼠标右击事件
    rightUpdata(MouseEvent, Object, Node, element) {
      this.id = Object.value;
      this.form.parentId = Object.value;
      this.form.parentName = Object.label;
      this.menuVisible = false;
      this.menuVisible = true;
      var menu = document.querySelector('#menu');
      menu.style.left = MouseEvent.clientX + 20 + 'px';
      menu.style.top = MouseEvent.clientY + 5 + 'px';
      document.addEventListener('click', this.foo);
      this.clickNode = Node;
    },
    foo() {
      this.menuVisible = false;
      document.removeEventListener('click', this.foo);
    },
    /*editTree({data}) {
      this.treeVisible = true;
      this.treeForm = JSON.parse(JSON.stringify(data));
    },*/

    // 打开父级项目选择框
    openType() {
      this.openUpType = true
    },
    // 选择父级项目 节点点击事件
    handleNodeClick2(data) {
      // 如果点击的id不相同，则重置点击次数
      if (data.value != this.form.parentId) {
        this.treeClickCnt = 0;
      }
      this.form.parentId = data.value
      this.form.parentName = data.label
      this.treeClickCnt++;

      // 注册清空点击次数计时器任务
      window.clearTimeout(this.treeClickTimeout);
      this.treeClickTimeout = window.setTimeout(() => {
        this.treeClickCnt = 0;
      }, 300);

      // 连续点击多次则不做任何事情
      if (this.treeClickCnt > 2) return;
      // 点击一次时单击事件
      if (this.treeClickCnt == 1) {
        // 单击事件
        console.log('单击');
      }
      // 点击两次时双击事件
      if (this.treeClickCnt == 2) {
        // 双击事件
        console.log('双击');
        this.submitUpType()
      }

    },
    // 保存父级项目
    submitUpType() {
      this.openUpType = false;
    },
    cancelUpType() {
      this.form.parentId = undefined
      this.form.parentName = undefined
      this.openUpType = false;
    },

    // 获取科目配置
    getdata(parameter) {
      this.loading = true
      findSubjectDescribeList(this.queryParams).then(res => {
        this.loading = false
        if (res.code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.listData = res.data.content
          // 分页赋值
          this.pageparm = res.data.pageparm
        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('加载失败，请稍后再试！')
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.queryParams.page = parm.currentPage
      this.queryParams.size = parm.pageSize
      this.getdata()
    },
    // 搜索事件
    search() {
      this.getdata()
    },
    //显示编辑界面
    handleEdit(x) {
      this.editFormShow = true
      if (x == 2) {
        this.title = '修改'
        querySubjectDetail(this.id).then(res => {
          if (res.code == 200) {
            this.form = res.data;
          }
        })
      } else {
        this.title = '添加'
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if (this.form.id != undefined) {
            // 修改
            updateSubject(this.form).then(res => {
              this.editFormShow = false
              this.loading = false
              if (res.code == 200) {
                // this.getdata()
                this.selectAreaTree()
                this.form = {}
                this.$message({
                  type: 'success',
                  message: '科目修改成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
              .catch(err => {
                this.editFormShow = false
                this.loading = false
                this.$message.error('科目修改失败，请稍后再试！')
              })
          } else {
            // 新增
            saveSubject(this.form).then(res => {
              this.editFormShow = false
              this.loading = false
              if (res.code == 200) {
                // this.getdata()
                this.selectAreaTree()
                this.form = {}
                this.$message({
                  type: 'success',
                  message: '科目保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
              .catch(err => {
                this.editFormShow = false
                this.loading = false
                this.$message.error('科目保存失败，请稍后再试！')
              })
          }
        } else {
          return false
        }
      })
    },
    // 删除 科目
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          querySubjectDetail(this.id).then(res => {
            if (res.code == 200) {
              this.form = res.data;
              deleteSubjectById(this.form).then(res => {
                if (res.code == 200) {
                  this.$message({
                    type: 'success',
                    message: '删除成功!'
                  })
                  this.form = {};
                  // this.getdata()
                  this.selectAreaTree()
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
              })
                .catch(err => {
                  this.loading = false
                  this.$message.error('删除失败，请稍后再试！')
                })
            }
          })

        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.form = {}
      this.editFormShow = false
    },

    /*
    *  科目配置信息
    * */
    handleFormEdit(index, row) {
      this.detailShow = true
      if (row != undefined && row != '') {
        this.detailTitle = '编辑'
        this.detailForm = JSON.parse(JSON.stringify(row))
      } else {
        this.detailTitle = '添加'
        this.detailForm = {
          subjectId: this.detailSubjectId
        }
      }
    },

    submitDetailForm() {
      this.$refs.detailForm.validate(valid => {
        if (valid) {
          if (this.detailForm.ageLimit.indexOf('-') == -1) {
            this.$message.error("区间请用‘-’符号分割");
            return
          } else {
            // 判断 '-' 前后的文字是否纯数字
            if(this.detailForm.ageLimit.split('-')[0] != parseInt(this.detailForm.ageLimit.split('-')[0])
              || this.detailForm.ageLimit.split('-')[1] != parseInt(this.detailForm.ageLimit.split('-')[1]))
            {
              this.$message.error("请按照以下格式输入：18-70");
              return
            }
          }
          if (this.detailForm.id != undefined) {
            // 修改
            updateSubjectDescribe(this.detailForm).then(res => {
              this.detailShow = false
              this.loading = false
              if (res.code == 200) {
                this.querySubjectDescribeBySubjectId(this.detailForm.subjectId)
                this.detailForm = {}
                this.$message({
                  type: 'success',
                  message: '科目配置修改成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
              .catch(err => {
                this.detailShow = false
                this.loading = false
                this.$message.error('科目配置修改失败，请稍后再试！')
              })
          } else {
            // 新增
            savaSubjectDescribe(this.detailForm).then(res => {
              this.detailShow = false
              this.loading = false
              if (res.code == 200) {
                this.querySubjectDescribeBySubjectId(this.detailForm.subjectId)
                this.detailForm = {}
                this.$message({
                  type: 'success',
                  message: '科目配置保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
              .catch(err => {
                this.detailShow = false
                this.loading = false
                this.$message.error('科目配置保存失败，请稍后再试！')
              })
          }
        } else {
          return false
        }
      })
    },

    deleteKmPz(index, row) {
      this.$confirm('确定要删除该条配置信息吗?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteSubjectDescribe(row).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.detailForm = {};
              this.getdata()
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('删除失败，请稍后再试！')
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },

    detailClose() {
      this.detailShow = false;
      this.detailForm = {}
    },

  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}

  /* 左侧树 搜索部分 */
  .tree-con {
    width: 250px;
    height: 95%;
    vertical-align: text-top;
    margin-top: 20px;
    display: inline-block;
    border: #014160 2px solid;
    border-radius: 8px;
  }
  .tree-con .custom-tree-node {
    width: 100%;
  }
  .tree-con .custom-tree-node .custom-tree-node-name {
    width: 80%;
    display: inline-block;
  }

  .head-search {
    border-radius: 8px 0 0 0 !important;
    margin-top: 0px;
    margin-bottom: 10px;
    padding-bottom: 10px;
  }
  /deep/ .tree-con input {
    border-radius: 8px 0 0 0 !important;
  }
  .head-tree {
    height: calc(100% - 55px);
    overflow-x: hidden;
  }

  /* 选中 高亮 */
/deep/ .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background-color: rgb(83, 131, 237) !important;
  color: #dadada;
}

  /* 右侧表格 */
  .con-rig {
    width: calc(100% - 270px);
    height: 95%;
    display: inline-block;
    flex-direction: column;
    margin-left: 10px;
    vertical-align: text-top;
  }

  /* 右键 树菜单 */
  .menu-item {
    display: block;
    line-height: 20px;
    text-align: center;
    margin-top: 2px;
  }
  .menu-item:hover{
    background-color: #66b1ff;
    color: white;
    cursor:pointer;
  }
  .menu {
    /*height: 35px;*/
    width: 90px;
    position: absolute;
    border: 1px solid #999;
    border-radius: 10px;
    background-color: #f4f4f4;
    padding: 5px 0px;
  }

  li:hover {
    background-color: #1790ff;
    color: white;
  }


  /deep/ .el-divider__text {
    font-size: 20px !important;
  }

</style>





// WEBPACK FOOTER //
// src/views/goods/subjectTree.vue